// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"793a782f","453":"af27a699","455":"8e1dd09e","977":"63cb2793"}[chunkId] + ".chunk.js";
};